import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import {
  DndContext,
  useDraggable,
  useDroppable,
  KeyboardSensor,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { injectModels } from "../../redux/injectModels";

// Sortable Item (used only in List B)
const SortableItem = ({
  id,
  title,
  index,
  props,
  handleDeleteVideo,
  handleVideoPreview,
  handleRegenerate,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    margin: " 5px 5px",
    gap: "12px",
    cursor: "grab",
  };

  return (
    <div
      key={title.sequence}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className="mergecontainer"
      style={style}
    >
      <div
        {...attributes}
        {...listeners}
        className=""
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          cursor: "grab",
        }}
      >
        <span
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            fontSize: "20px",
            color: "#888",
            paddingRight: "8px",
          }}
          title="Drag and Drop"
        >
          ⠿
        </span>
        <div className="videonumber">{index + 1}</div>

        <div className="videoimgage">
          <video
            src={
              title.video_url ? title.video_url : "/videos/default-video.mp4"
            }
            className=""
          />
        </div>

        <div className="videotitle dragitems">
          <h3>
            {title.type === "generated"
              ? `${title.start} ${title.end}`
              : title.video_name}
          </h3>
        </div>
      </div>
      {/* <div className="videotools"></div> */}
    </div>
  );
};
// Simple draggable item (used in List A)
const DraggableItem = ({
  id,
  title,
  index,
  props,
  handleDeleteVideo,
  handleVideoPreview,
  handleRegenerate,
}) => {
  const isUploading = title.type === "uploading";
  const isUploadError = title.type === "upload_error";
  const disableDrag = isUploading || isUploadError;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: disableDrag });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : disableDrag ? 0.6 : 1,
    position: "relative",
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    margin: "7px 10px 0px 0px",
    gap: "12px",
  };
  const handleSafeClick = (e, callback) => {
    e.stopPropagation(); // ✅ stop drag
    if (typeof callback === "function") {
      callback();
    }
  };

  return (
    <div
      key={title.sequence}
      ref={setNodeRef}
      className="mergecontainer "
      style={style}
    >
      <div
        {...(!disableDrag ? attributes : {})}
        {...(!disableDrag ? listeners : {})}
        className=""
        style={{
          width: "100%",
          height: "60px",
          display: "flex",
          alignItems: "center",
          columnGap: "10px",
          cursor: disableDrag ? "not-allowed" : "grab",
        }}
      >
        <span
          style={{
            cursor: disableDrag ? "not-allowed" : "grab",
            fontSize: "20px",
            color: "#888",
            paddingRight: "8px",
            position: "absolute",
            display: "flex",
            alignItems: "center",
          }}
          title="Drag and Drop"
        >
          ⠿
        </span>
        <div className="videonumber">{index + 1}</div>

        <div className="videoimgage">
          <video
            preload="auto"
            src={
              title.video_url ? title.video_url : "/videos/default-video.mp4"
            }
            className=""
          />
        </div>

        {/* <div className="videotitle">
          <h3
           className="truncate-text"
            title={
              title.type === "generated"
                ? `${title.start} ${title.end}`
                : title.video_name
            }
          >
            {title.type === "generated"
              ? `${title.start} ${title.end}`
              : title.video_name}
          </h3>
        </div> */}
        <div className="videotitle">
          <div
            className="truncate-wrapper"
            data-tooltip={
              title.type === "generated"
                ? `${title.start} ${title.end}`
                : title.video_name
            }
          >
            <h3 className="truncate-text">
              {title.type === "generated"
                ? `${title.start} ${title.end}`
                : title.video_name}
            </h3>
          </div>
        </div>
      </div>

      {/* <div className="videotools">
        <button
          title="Video"
          onClick={() => handleVideoPreview(title)}
          className="btn btn-primary btn-sm"
          data-no-dnd="true"
        >
          <i className="fa-solid fa-eye"></i>
        </button>

        <Link
          to={
            title.type === "generated"
              ? title.download_video_url
              : title.video_download_url
          }
        >
          <button className="btn btn-primary btn-sm">
            <i className="fa-solid fa-download"></i>
          </button>
        </Link>

        <button
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleDeleteVideo(title.merge_request_item_id);
          }}
          className="btn btn-danger btn-sm"
          data-no-dnd="true"
        >
          <i className="fa-solid fa-delete-left"></i>
        </button>
      </div> */}
      <div className="videotools">
        {title.type === "uploading" && (
          <>
            <button type="button" className="btn btn-sm btn-outline-primary">
              Processing...
            </button>
          </>
        )}

        {title.type === "upload_error" && (
          <>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              disabled={title.type === "upload_error"}
            >
              Failed
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-success"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleRegenerate(title);
              }}
            >
              Regenerate
            </button>
          </>
        )}
        {(title.type === "generated" || title.type === "uploaded") && (
          <>
            <button
              onClick={(e) =>
                handleSafeClick(e, () => handleVideoPreview(title))
              }
              className="btn btn-primary btn-sm"
              data-no-dnd="true"
              title="view"
            >
              <i className="fa-solid fa-eye"></i>
            </button>

            {/* ⬇️ Download */}
            <Link
              to={
                title.type === "generated"
                  ? title.download_video_url
                  : title.video_download_url
              }
              data-no-dnd="true"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="btn btn-primary btn-sm" title="Download">
                <i className="fa-solid fa-download"></i>
              </button>
            </Link>

            {/* 🗑 Delete */}
            <button
              onClick={(e) =>
                handleSafeClick(e, () =>
                  handleDeleteVideo(title.merge_request_item_id)
                )
              }
              className="btn btn-danger btn-sm"
              data-no-dnd="true"
              title="Delete"
            >
              <i className="fa-solid fa-delete-left"></i>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

// Droppable list component
const DroppableList = ({
  id,
  videos,
  title,
  allowSort,
  props,
  handleDeleteVideo,
  handleVideoPreview,
  handleRegenerate,
  setSearchTerm,
  searchTerm,
  draggedVideo,
  setDraggedVideo,
  isVideoInMergeQueue,
}) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  const style = {
    minHeight: 200,
    padding: 10,
    border: "2px dashed #aaa",
    borderRadius: 5,
    background: isOver ? "#e0ffe0" : "white",
  };

  return (
    <div style={{ width: "50%", flexDirection: "column" }}>
      <div className="listgdghdh">
        <h3>{title}</h3>
        {id === "A" && (
          <div>
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search by heading..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        )}
      </div>
      <div ref={setNodeRef} className="videoscrolling">
        {videos.length === 0 ? (
          <div
            style={{
              color: "#888",
              minHeight: "400px",
            }}
            className="custom-video-box"
          >
            {id === "A" ? " No Video" : "Drag and drop videos here to merge"}
          </div>
        ) : allowSort ? (
          <SortableContext
            items={videos.map((v) => String(v.merge_request_item_id))}
            strategy={verticalListSortingStrategy}
          >
            {videos.map((video, index) => {
              const isDisabled = isVideoInMergeQueue(video.id);
              const isDragging = draggedVideo === video.id;

              return (
                <SortableItem
                  key={video.merge_request_item_id}
                  id={String(video.merge_request_item_id)}
                  title={video}
                  index={index}
                  props={props}
                  handleDeleteVideo={handleDeleteVideo}
                  handleVideoPreview={handleVideoPreview}
                />
              );
            })}
          </SortableContext>
        ) : (
          videos.map((item, index) => (
            <DraggableItem
              key={item.merge_request_item_id}
              id={String(item.merge_request_item_id)}
              title={item}
              index={index}
              props={props}
              handleDeleteVideo={handleDeleteVideo}
              handleVideoPreview={handleVideoPreview}
              handleRegenerate={handleRegenerate}
            />
          ))
        )}
      </div>
    </div>
  );
};

// Main component
const MergeVideosDND = ({
  videos,
  setVideos,
  props,
  fetchVideos,
  fetchDuration,
  videosSessionId,
  mergeList,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [showVideoPreview, setShowVideoPreview] = useState(false);
  const [showVideoTitlePreview, setShowVideoTitlePreview] = useState(false);
  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const [department, setDepartment] = useState("");
  const [isFunction, setIsFunction] = useState("");
  const [draggedVideo, setDraggedVideo] = useState(null);
  const [mergeQueue, setMergeQueue] = useState([]);
  const [titleError, setTitleError] = useState("");
  const [headingError, setHeadingError] = useState("");
  const [departmentError, setDepartmentError] = useState("");
  const [isFunctionError, setIsFunctionError] = useState("");
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [isAIVoice, setIsAIVoice] = useState(false);

  const handleVideoTitleCloseModel = () => {
    setTitle("");
    setDepartment("");
    setIsFunction("");
    setHeading("");
    setHeadingError("");
    setDepartmentError("");
    setIsFunctionError("");
    setTitleError("");
    setShowVideoTitlePreview(false);
  };

  const handleDeleteVideo = async (itemId) => {
    if (!itemId) {
      toast.dismiss();
      toast.error("Invalid video ID.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      const response = await props.admin.deleteMergeVideo(itemId);

      if (response?.success) {
        toast.dismiss();
        toast.success("Video deleted successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });

        // Optional: Refresh video list
        fetchVideos?.();
        fetchDuration?.(); // Call your fetchVideos function if defined
      } else {
        toast.dismiss();
        toast.error("Failed to delete video.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.dismiss();
      toast.error("An error occurred while deleting the video.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleVideoPreview = (title) => {
    setSelectedVideoUrl(title);
    setShowVideoPreview(true);

    toast.dismiss();
  };

  const handleTitle = (event) => {
    const input = event.target.value;

    if (!/^\d*$/.test(input)) {
      setTitleError("You can only enter numbers. Alphabets are not allowed.");
      return;
    }
    if (input === "") {
      setTitleError("Step Number is required!");
    } else {
      setTitleError("");
    }
    setTitle(input);
  };
  const handleHeading = (event) => {
    const input = event.target.value;
    if (input === "") {
      setHeadingError("Heading is required!");
    } else {
      setHeadingError("");
    }
    setHeading(input);
  };

  const handleDepartment = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setDepartmentError("Department is required!");
    } else {
      setDepartmentError("");
    }
    setDepartment(input);
  };
  const handleFunction = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setIsFunctionError("Function is required!");
    } else {
      setIsFunctionError("");
    }
    setIsFunction(input);
  };

  const handleMergeFinal = async () => {
    // Validate title input
    if (!title.trim()) {
      setTitleError("Step Number is required");
      return;
    }
    if (!heading.trim()) {
      setHeadingError("Heading is required");
      return;
    }
    if (!department.trim()) {
      setDepartmentError("Department is required");
      return;
    }
    if (!isFunction.trim()) {
      setIsFunctionError("Function is required");
      return;
    }

    const cleanInput = title.trim().toLowerCase();

    // SAFE CHECK → mergeList must be an array
    if (Array.isArray(mergeList)) {
      const isDuplicate = mergeList.some((item) => {
        const fileName = (item.final_video_name || "").toLowerCase();
        const nameWithoutExt = fileName.replace(/\.[^/.]+$/, ""); // remove extension
        return nameWithoutExt === cleanInput;
      });

      if (isDuplicate) {
        setTitleError("Step number already exists!");
        return; // STOP submitting
      } else {
        setTitleError("");
      }
    } else {
      console.warn("mergeList is not loaded or is undefined.");
    }

    // Validate number of videos
    // if (listB.length < 2) {
    //   toast.dismiss();
    //   toast.error("At least 2 videos are required to merge", {
    //     position: "top-center",
    //   });
    //   return;
    // }

    const formData = new FormData();

    formData.append("session_id", videosSessionId);
    formData.append("step_number", cleanInput);
    formData.append("department", department);
    formData.append("heading", heading);
    formData.append("function", isFunction);
    // formData.append("ai_voice", isAIVoice);

    try {
      props.application.setLoading(true);

      const res = await props.admin.videoEnhancement(formData);

      if (res?.success) {
        const payload = {
          session_id: videosSessionId,
          video_name: cleanInput,
          videos: listB.map((item) => ({
            type: item.type,
            id:
              item.type === "generated"
                ? item.video_generation_id
                : item.merge_request_item_id,
          })),
          video_id: res?.data?.video_id,
          ai_voice: isAIVoice,
        };

        const response = await props.admin.MergeAllVideo(payload);
        if (response?.success) {
          setTitle("");
          setTitleError("");
          setDepartment("");
          setDepartmentError("");
          setHeading("");
          setHeadingError("");
          setIsFunction("");
          setIsFunctionError(" ");
          handleVideoTitleCloseModel();
          toast.dismiss();
          toast.success(res.message, { position: "top-center" });

          await fetchVideos?.(); // Refresh list
        }
      } else {
        toast.dismiss();
        toast.error(res?.message || "Something went wrong!", {
          position: "top-center",
        });
      }

      console.log("Submitted selected videos:", res);
    } catch (error) {
      toast.dismiss();
      console.error("Error submitting videos:", error);
      toast.error("Failed to submit videos. Please try again.", {
        position: "top-center",
      });
    } finally {
      props.application.setLoading(false);
    }
  };

  const listA = videos.filter(
    (item) =>
      item.location === "A" &&
      (item.start
        ?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
        item.video_name
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.end?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const handleRearrange = async (reorderedVideos) => {
    try {
      const result = reorderedVideos.reduce((acc, item, index) => {
        acc[index] = [item.merge_request_item_id, index + 1];
        return acc;
      }, {});

      console.log(result);

      const response = await props.admin.rearrangeVideo(result);

      if (response.success) {
        await fetchVideos(); // list refresh
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Failed to regenerate video");
    }
  };
  const listB = videos.filter((item) => item.location === "B");
  const handleDragStart = (event) => {
    setDraggedVideo(event.active.id);
  };
  const handleDragOver = (event) => {
    const { active, over } = event;
    if (!over) return;

    const activeId = active.id;
    const overId = over.id;

    if (
      overId === "merge-queue" &&
      !mergeQueue.find((v) => v.id === activeId)
    ) {
      const videoToAdd = videos.find((v) => v.id === activeId);
      if (videoToAdd) {
        setMergeQueue((prev) => [...prev, videoToAdd]);
      }
    }

    if (overId === "video-list" && mergeQueue.find((v) => v.id === activeId)) {
      setMergeQueue((prev) => prev.filter((v) => v.id !== activeId));
    }
  };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    const activeId = parseInt(active.id);
    const overId = parseInt(over.id);

    const activeItem = videos.find((v) => v.merge_request_item_id === activeId);
    const overItem = videos.find((v) => v.merge_request_item_id === overId);

    const activeList = activeItem.location;
    const overList = overItem?.location || over.id;

    if (activeList !== overList) {
      // Move item between lists
      setVideos((prev) =>
        prev.map((item) =>
          item.merge_request_item_id === activeId
            ? { ...item, location: overList }
            : item
        )
      );
    } else if (overList === "B") {
      // Reorder inside List B
      const listBItems = videos
        .filter((v) => v.location === "B")
        .map((v) => v.merge_request_item_id.toString());

      const oldIndex = listBItems.indexOf(active.id);
      const newIndex = listBItems.indexOf(over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const reordered = arrayMove(listBItems, oldIndex, newIndex);

        const reorderedVideos = [
          ...videos.filter((v) => v.location !== "B"),
          ...reordered.map((id) =>
            videos.find((v) => v.merge_request_item_id === parseInt(id))
          ),
        ];

        setVideos(reorderedVideos);
      }
    } else if (overList === "A" || overList === "B") {
      // Reorder inside same list
      const listItems = videos
        .filter((v) => v.location === overList)
        .map((v) => v.merge_request_item_id.toString());

      const oldIndex = listItems.indexOf(active.id);
      const newIndex = listItems.indexOf(over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const reordered = arrayMove(listItems, oldIndex, newIndex);

        const reorderedVideos = [
          ...videos.filter((v) => v.location !== overList),
          ...reordered.map((id) =>
            videos.find((v) => v.merge_request_item_id === parseInt(id))
          ),
        ];
        handleRearrange(reorderedVideos);
        setVideos(reorderedVideos);
      }
    }
  };

  const isVideoInMergeQueue = (videoId) => {
    return mergeQueue.some((v) => v.id === videoId);
  };
  const handleRegenerate = async (item) => {
    try {
      props.application.setLoading(true);

      // const payload = {
      //   merge_request_item_id: item.merge_request_item_id,
      // };

      const response = await props.admin.regenerateVideo(
        item.merge_request_item_id,
        videosSessionId
      );

      if (response.success) {
        toast.success(response.message || "Regeneration started successfully");
        await fetchVideos(); // list refresh
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Failed to regenerate video");
    } finally {
      props.application.setLoading(false);
    }
  };

  return (
    <div>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
        onDragOver={handleDragOver}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: " 20px",
            columnGap: "30px",
          }}
          className=""
        >
          <DroppableList
            id="A"
            videos={listA}
            title={`Video List (${videos.length})`}
            allowSort={false}
            props={props}
            handleDeleteVideo={handleDeleteVideo}
            handleVideoPreview={handleVideoPreview}
            handleRegenerate={handleRegenerate}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            draggedVideo={draggedVideo}
            isVideoInMergeQueue={isVideoInMergeQueue}
            setDraggedVideo={setDraggedVideo}
          />
          <DroppableList
            id="B"
            videos={listB}
            title={`Merge Queue (${listB.length})`}
            allowSort={true}
            props={props}
            handleDeleteVideo={handleDeleteVideo}
            handleVideoPreview={handleVideoPreview}
            handleRegenerate={handleRegenerate}
            draggedVideo={draggedVideo}
            isVideoInMergeQueue={isVideoInMergeQueue}
            setDraggedVideo={setDraggedVideo}
          />
        </div>
        {listB.length > 0 && (
          <div className="" style={{ display: "flex", justifyContent: "end" }}>
            <button
              onClick={() => setShowVideoTitlePreview(true)}
              className="custom-generate-button mt-2"
              style={{ maxWidth: "200px" }}
            >
              Merging ({listB.length}) Videos
            </button>
          </div>
        )}
      </DndContext>
      <Modal
        show={showVideoPreview}
        onHide={() => setShowVideoPreview(false)}
        centered
      >
        <Modal.Header closeButton style={{ gap: "5px" }}>
          <Modal.Title>
            {selectedVideoUrl?.type === "generated"
              ? `${selectedVideoUrl?.start} ${selectedVideoUrl?.end}`
              : selectedVideoUrl?.video_name?.replace(/\.mp4$/, "")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVideoUrl?.video_url ? (
            <div style={{ textAlign: "center" }}>
              <video
                key={showVideoPreview ? selectedVideoUrl?.video_url : ""} // 🔹 Force re-mount
                id="videoPlayer"
                src={selectedVideoUrl?.video_url}
                controls
                autoPlay
                style={{ width: "100%" }}
                preload="auto"
              />
            </div>
          ) : (
            <p>No video available</p>
          )}
        </Modal.Body>
      </Modal>

      {showVideoTitlePreview && (
        <Modal
          show={showVideoTitlePreview}
          onHide={handleVideoTitleCloseModel}
          size="lg"
          // dialogClassName="custom-modal-width"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title> Merge Video Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-6 mb-2">
                <label htmlFor="" className="form-label">
                  Step Number<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  // className="form-control"
                  className={`form-control ${titleError ? "error-border" : ""}`}
                  id=""
                  value={title}
                  onChange={handleTitle}
                  maxLength={250}
                  placeholder="Enter step number..."
                />
                {titleError && <div className="text-danger">{titleError}</div>}
              </div>
              <div className="col-6 mb-2">
                <label htmlFor="" className="form-label">
                  Heading<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    headingError ? "error-border" : ""
                  }`}
                  id=""
                  value={heading}
                  onChange={handleHeading}
                  maxLength={250}
                  placeholder="Enter heading..."
                />
                {headingError && (
                  <div className="text-danger">{headingError}</div>
                )}
              </div>

              <div className="col-6 mb-2">
                <label htmlFor="" className="form-label">
                  Department<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    departmentError ? "error-border" : ""
                  }`}
                  id=""
                  value={department}
                  onChange={handleDepartment}
                  maxLength={250}
                  placeholder="Enter department..."
                />
                {departmentError && (
                  <div className="text-danger">{departmentError}</div>
                )}
              </div>
              <div className="col-6 mb-2">
                <label htmlFor="" className="form-label">
                  Function<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    isFunctionError ? "error-border" : ""
                  }`}
                  id=""
                  value={isFunction}
                  onChange={handleFunction}
                  maxLength={250}
                  placeholder="Enter function..."
                />
                {isFunctionError && (
                  <div className="text-danger">{isFunctionError}</div>
                )}
              </div>
              <div className="col-12 mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="aiVoice"
                    checked={isAIVoice}
                    onChange={(e) => setIsAIVoice(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="aiVoice">
                    Enable AI Voice
                  </label>
                </div>
              </div>
            </div>
            <div
              className=""
              style={{ display: "flex", justifyContent: "end" }}
            >
              <button
                onClick={handleMergeFinal}
                className="btn btn-primary mt-2 m-0 "
                // disabled={title.trim() === ""}
              >
                Start Merge
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default injectModels(["admin", "application", "application"])(
  MergeVideosDND
);
